export default "__VITE_ASSET__BNzYKItg__"